// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signupFormContent{font-size:.875rem;text-align:left}.signupFormContent div:not([class*=checkboxDesc]) label{color:#120a20;font-size:1rem;font-weight:700}.signupFormContent p{color:#aaa7b0;font-size:.875rem}._4FFlHoeMZh1qm5-yuq8TT{margin-bottom:1.5rem}._4FFlHoeMZh1qm5-yuq8TT span{margin:0}", ""]);
// Exports
exports.locals = {
	"or": "_4FFlHoeMZh1qm5-yuq8TT"
};
module.exports = exports;
